import compiledEn from "~/compiled-lang/compiled-en.json";
import compiledSv from "~/compiled-lang/compiled-sv.json";
import { SupportedLanguage } from "./SupportedLanguage";

export async function getTranslations(locale: SupportedLanguage) {
  switch (locale) {
    case SupportedLanguage.EN: {
      return compiledEn;
    }

    case SupportedLanguage.SV: {
      return compiledSv;
    }

    default: {
      const imported = await import("~/compiled-lang/compiled-en.json");
      return imported.default;
    }
  }
}
